import React from 'react';
import i18n from 'i18n-js';

import CommonInputValidation from '../../Container/ComomInputValidation'
import FormOfPayment from './FormOfPayment';
import * as Icon from 'react-bootstrap-icons';
import ReactTooltip from 'react-tooltip';

let totalPrice = 0;
let totalPriceCurrency: any = null;
let totalFeePrice = 0;
let usedDolgeyCoins = 0;
let newTotal = '';

const TableTite = () => {
  return (
    <tr className="box-title">
      <td>{i18n.t('name')}</td>
      <td>{i18n.t('serviceType')}</td>
      <td>{i18n.t('start')}</td>
      <td>{i18n.t('end')}</td>
      <td>{i18n.t('dogs')}</td>
      <td>{i18n.t('days')}</td>
      <td align="right">{i18n.t('price')}</td>
    {
      // <li>{i18n.t('subTotal')}</li>
    }
    </tr>
  )
}


const calcList = (key: any, bookingInfoCalcData: any, userBookingInformation: any, solutionValStr: any, dogCount: any, isHoliday: boolean) => {

  if (isHoliday) {
    totalPrice += parseFloat(bookingInfoCalcData.price);
  } else {
    totalPrice += parseFloat(bookingInfoCalcData.originalPrice);
  }

  if(bookingInfoCalcData.bookingFee){
    totalFeePrice += parseFloat(bookingInfoCalcData.bookingFee);
  }

  return (
    <tr key={key}>
      <td className="bold">{userBookingInformation.owner.firstName} {userBookingInformation.owner.lastName}</td>
      <td>{
        isHoliday ?
          i18n.t("holidayPrice")
          :
          solutionValStr
        }
        {
          isHoliday ?
            <p style={{ fontSize: "10px" }}>{ bookingInfoCalcData.name }</p>
            : null
        }
      </td>
      <td>
        {
          isHoliday ?
            bookingInfoCalcData.dates[0]
            :
            bookingInfoCalcData.fromdate
        }
      </td>
      <td>
        {
          isHoliday ?
            bookingInfoCalcData.dates[bookingInfoCalcData.dates.length - 1]
            :
            bookingInfoCalcData.todate
        }
      </td>
      <td>{dogCount}</td>
      <td>
        {
          isHoliday ?
            bookingInfoCalcData.dates.length
            :
            bookingInfoCalcData.days || 0
        }
      </td>
      <td align="right">
        {
          isHoliday ?
            (Math.round(bookingInfoCalcData.price * 100) / 100).toFixed(2).replace(".", ",")
            :
            (Math.round(bookingInfoCalcData.originalPrice * 100) / 100).toFixed(2).replace(".", ",")
        } {totalPriceCurrency}</td>
    </tr>
  )
}

const TableList = (props: any) => {
  const { bookingInfoCalcData, dateFrom, dateTo, userBookingInformation, dogCount, solutionValue } = props;

  let dataList = [];
  totalPrice = 0;
  totalFeePrice = 0;

  let solutionValStr = "";


  for(let x=0; x < userBookingInformation.solutions.length; x++) {
    if (userBookingInformation.solutions[x].uid === solutionValue) {
      solutionValStr = userBookingInformation.solutions[x].description;
      break;
    }
  }

  if (bookingInfoCalcData.length) {
    for(let x = 0; x < bookingInfoCalcData.length; x++) {
      dataList.push(calcList(
        x,
        bookingInfoCalcData[x],
        userBookingInformation,
        solutionValStr,
        dogCount,
        false
      ));

      let holidays = bookingInfoCalcData[x].holidays;
      totalPriceCurrency = bookingInfoCalcData[x].currency;

      if (holidays && holidays.length) {
        for(let y = 0; y < holidays.length; y++) {
          dataList.push(calcList(
            `a${x}${y}`,
            holidays[y],
            userBookingInformation,
            solutionValStr,
            dogCount,
            true
          ));
        }
      }
    }
  } else {
    dataList.push(calcList(
      0,
      bookingInfoCalcData,
      userBookingInformation,
      solutionValStr,
      dogCount,
      false
    ));

    let holidays = bookingInfoCalcData.holidays;
    totalPriceCurrency = bookingInfoCalcData.currency;

    if (holidays && holidays.length) {
      for(let y = 0; y < holidays.length; y++) {
        dataList.push(calcList(
          `a0${y}`,
          holidays[y],
          userBookingInformation,
          solutionValStr,
          dogCount,
          true
        ));
      }
    }
  }

  return (
    <div className="box-list">
      <table>
        <tbody>
          <TableTite />
          {dataList}
          <tr className="box-total">
            <td colSpan={4}></td>
            <td colSpan={2} className="bold">{solutionValStr}</td>
            <td className="bold" align="right">{(Math.round(totalPrice * 100) / 100).toFixed(2).replace(".", ",")} {totalPriceCurrency}</td>
          </tr>
          <tr className="box-total">
            <td colSpan={4}></td>
            <td colSpan={2} className="bold">{i18n.t('serviceFee')}</td>
            <td className="bold" align="right">{(Math.round(totalFeePrice * 100) / 100).toFixed(2).replace(".", ",")} {totalPriceCurrency}</td>
          </tr>
          <tr className="box-total">
            <td colSpan={4}></td>
            <td colSpan={2} className="bold">{i18n.t('total')}</td>
            <td className="bold" align="right">{(Math.round((totalPrice + totalFeePrice) * 100) / 100).toFixed(2).replace(".", ",")} {totalPriceCurrency}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

const FormApproveOrder = (props: any) => {
  const { changeCheckoutForm, checkoutIndex, submitBooking, bookingInfoCalcData, setStateValue, message, userBookingInformation, form, isCoupon } = props;

  const cssWrapper = checkoutIndex === 2 ? 'box-wrapper show' : 'box-wrapper hide';

  let maxCoinToUse  = 0;

  if(bookingInfoCalcData && bookingInfoCalcData.length){
    bookingInfoCalcData.map((item: any) => {
      maxCoinToUse += item.maxCoinToUse;
    });
  } else if(bookingInfoCalcData && !bookingInfoCalcData.length){
    maxCoinToUse  = bookingInfoCalcData.maxCoinToUse;
  }

  maxCoinToUse = maxCoinToUse <= 0 ? 0 : maxCoinToUse ;
  maxCoinToUse = bookingInfoCalcData && bookingInfoCalcData.length && maxCoinToUse >= bookingInfoCalcData[0].dogleyCoinBalance ? bookingInfoCalcData[0].dogleyCoinBalance : (bookingInfoCalcData && !bookingInfoCalcData.length && maxCoinToUse >= bookingInfoCalcData.dogleyCoinBalance ? bookingInfoCalcData.dogleyCoinBalance : maxCoinToUse );

  return (
    <div className="form-of-payment box-form">
      <p  onClick={() => changeCheckoutForm(2)} className="sub-title">{i18n.t('approveOrder')}</p>
      {
        checkoutIndex === 2 ?
          <div className={cssWrapper}>
            <div className="box-input-field">
              <CommonInputValidation
                label={i18n.t('street')}
                name="address"
                value={userBookingInformation.owner.address}
                required={true}
                setStateValue={setStateValue}
                form={form}
              />
            </div>
            <div className="box-input-field">
              <CommonInputValidation
                label={i18n.t('zipCode')}
                name="zip"
                value={userBookingInformation.owner.zip}
                required={true}
                setStateValue={setStateValue}
                form={form}
              />
            </div>
            <div className="box-input-field">
              <CommonInputValidation
                label={i18n.t('town')}
                name="city"
                value={userBookingInformation.owner.city}
                required={true}
                setStateValue={setStateValue}
                form={form}
              />
            </div>
            <div className="box-message-dogsitter">
              <p>
                {
                  props.solutionValue === 2 ?
                    i18n.t('dogcareToStartAndEnd')
                    :
                    i18n.t('dogcareToStartAndEnd2')
                }
              </p>
              <textarea placeholder={i18n.t('messageToDogsitter')} onChange={(e) => {
                  setStateValue({ message: { value : e.target.value, error: false, label: i18n.t('messageToDogsitter'), errorMessage: null } })
                  // if (e.target.value) {
                  //   setStateValue({ message: { value : e.target.value, error: false, label: i18n.t('messageToDogsitter'), errorMessage: null } })
                  // } else {
                  //   setStateValue({ message: { value : e.target.value, error: false, label: i18n.t('messageToDogsitter'), errorMessage: (`${i18n.t('messageToDogsitter')} Skal udfyldes`).trim() } })
                  // }
                }}
              />
              {
                message && message.error ?
                  <p className="required">{message.errorMessage}</p>
                  : null
              }
            </div>
              {
                bookingInfoCalcData ?
                  <TableList {...props} />
                  : null
              }

              <div className="box-coupon">
                <p className="have-coupon-click hide">
                  <a onClick={() => setStateValue({ isCoupon: !isCoupon })}>{i18n.t("coupon")}</a>
                </p>
                {
                  isCoupon ?
                    <div>
                      <div className="box-input-field">
                        <input placeholder={i18n.t("enterYourDiscountCode")} />
                      </div>

                      <div className="box-btn pd-bottom-20">
                        <button className="sky-blue">
                          {i18n.t('applyCoupon')}
                        </button>
                      </div>
                    </div>
                    : null
                }
                {
                  // <div className="box-btn ">
                  //   <button className="red" onClick={() => submitBooking(3)}>
                  //     {i18n.t('continue')}
                  //   </button>
                  // </div>
                }
                <div className="row dogley-coin-field box-input-field">
                  <div className="col-8">
                    <b>{i18n.t('dogleyCoinsBalance')}</b> <span data-tip={i18n.t('dogleyCoinsInfo')}><Icon.InfoCircleFill /></span>
                    <ReactTooltip effect="solid" place="top" />
                  </div>
                  <div id="dogleyCoinBalanceField" className="col-4 text-right">
                  { bookingInfoCalcData && !bookingInfoCalcData.length ? bookingInfoCalcData.dogleyCoinBalance : (bookingInfoCalcData && bookingInfoCalcData.length ? bookingInfoCalcData[0].dogleyCoinBalance : '' ) }
                  </div>
                </div>
                <div className="row dogley-coin-field box-input-field">
                  <div className="col-8"><b>{i18n.t('useNumberOfDogleyCoins')}</b></div>
                  <div className="col-4">
                    <input className="text-right" defaultValue="0" type="number" id="usedDolgeyCoins" name="dogleyCoins" onDrop={(e: any) => {e.preventDefault()}} min="0" max={maxCoinToUse} onChange={(e) => {
                      e.target.value      = parseInt(e.target.value) > maxCoinToUse ? maxCoinToUse.toString() : Math.abs(parseInt(e.target.value)).toString() ;
                      usedDolgeyCoins     = parseInt(e.target.value) ? parseInt(e.target.value) : 0;
                      const coinWorth     = bookingInfoCalcData.length ? bookingInfoCalcData[0].dogleyCoinWorth : bookingInfoCalcData.dogleyCoinWorth;
                      const priceReduce   = usedDolgeyCoins * coinWorth;
                      const coinBalance   = bookingInfoCalcData.length ? bookingInfoCalcData[0].dogleyCoinBalance : bookingInfoCalcData.dogleyCoinBalance ;
                      document.getElementById("dogleyCoinBalanceField").innerHTML = (coinBalance - usedDolgeyCoins).toString();
                      document.getElementById("newTotalField").innerHTML          = (Math.round((totalPrice + totalFeePrice - priceReduce) * 100) / 100).toFixed(2).replace(".", ",")+' '+totalPriceCurrency;
                      form.dogleyCoins  = {
                        value         : e.target.value,
                        label         : "DogleyCoins",
                        name          : "dogleyCoins",
                        errorMessage  : "",
                        required      : false
                      };
                    }}/>
                  </div>
                </div>
                <div className="row dogley-coin-field box-input-field">
                  <div className="col-8"><b>{i18n.t('yourPrice')}</b></div>
                  <div className="col-4 bold text-right" id="newTotalField">
                    {(Math.round((totalPrice + totalFeePrice) * 100) / 100).toFixed(2).replace(".", ",")+' '+totalPriceCurrency}
                  </div>
                </div>
                <div className="box-btn pd-bottom-20">
                  <button className="red" onClick={() => submitBooking('submit')}>
                    {i18n.t('executeOrder')}
                  </button>
                </div>
              </div>
              <FormOfPayment
                {...props}
              />
          </div>
          : null
      }
    </div>
  );
}

export default FormApproveOrder;
